var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocklight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6.5H13C13.1989 6.5 13.3897 6.57902 13.5303 6.71967C13.671 6.86032 13.75 7.05109 13.75 7.25V14.75C13.75 14.9489 13.671 15.1397 13.5303 15.2803C13.3897 15.421 13.1989 15.5 13 15.5H1C0.801088 15.5 0.610322 15.421 0.46967 15.2803C0.329018 15.1397 0.25 14.9489 0.25 14.75V7.25C0.25 7.05109 0.329018 6.86032 0.46967 6.71967C0.610322 6.57902 0.801088 6.5 1 6.5H1.75V5.75C1.75 5.06056 1.8858 4.37787 2.14963 3.74091C2.41347 3.10395 2.80018 2.5252 3.28769 2.03769C3.7752 1.55018 4.35395 1.16347 4.99091 0.899632C5.62787 0.635795 6.31056 0.5 7 0.5C7.68944 0.5 8.37213 0.635795 9.00909 0.899632C9.64605 1.16347 10.2248 1.55018 10.7123 2.03769C11.1998 2.5252 11.5865 3.10395 11.8504 3.74091C12.1142 4.37787 12.25 5.06056 12.25 5.75V6.5ZM1.75 8V14H12.25V8H1.75ZM6.25 9.5H7.75V12.5H6.25V9.5ZM10.75 6.5V5.75C10.75 4.75544 10.3549 3.80161 9.65165 3.09835C8.94839 2.39509 7.99456 2 7 2C6.00544 2 5.05161 2.39509 4.34835 3.09835C3.64509 3.80161 3.25 4.75544 3.25 5.75V6.5H10.75Z",
    fill: "#525866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocklight);
export default __webpack_public_path__ + "static/media/locklight.ec54c035da003ec968a049222faf72c8.svg";
export { ForwardRef as ReactComponent };